import {Injectable} from '@angular/core';
import Quill from 'quill';

const EDITOR_FONT_SIZES = ['12px', '14px', '16px', '18px', '20px', '22px', '24px', '26px', '28px', '32px', '36px', '40px'];

/**
 * Makes Quill's inline-style attributor THE `size` format and adds these sizes to what it accepts.
 *
 * It has to be registered as the format itself (`Quill.register(SizeStyle, true)` files it under
 * `formats/size`). Registering it under its import path only leaves Quill's default class-based
 * size format in charge, which accepts small/large/huge and silently drops a px size, so choosing a
 * size in the toolbar did nothing. The attributor is also one global object shared by every editor
 * in the app, so callers ADD to its whitelist: replacing it (as the email composer did with its own
 * 10/18/28px) disabled every other size in every other editor for the rest of the session.
 *
 * @param {string[]} sizes - font sizes this caller's toolbar offers, e.g. ['12px', '14px'].
 */
export function registerInlineFontSizes(sizes: string[]): void {
  const SizeStyle = Quill.import('attributors/style/size') as any;
  SizeStyle.whitelist = Array.from(new Set([...(SizeStyle.whitelist ?? []), ...sizes]));
  Quill.register(SizeStyle, true);
}

registerInlineFontSizes(EDITOR_FONT_SIZES);


@Injectable({
    providedIn: 'root'
})
export class QuillConfigService {

    constructor() {
    }

    /**
     * Returns the configuration modules for the editor, including toolbar and clipboard settings.
     * @param {boolean} isBlogEditor - Determines if the editor should use the blog-specific toolbar configuration.
     * @return {object} The editor modules configuration object containing toolbar and clipboard settings.
     */
    getEditorModules(isBlogEditor = false): any {
        return {
            toolbar: [
                [{ 'size': EDITOR_FONT_SIZES }],
                ['bold', 'italic', 'underline', 'link','blockquote'],
                [{list: 'ordered'}, {list: 'bullet'}],
                [{indent: '-1'}, {indent: '+1'}],
                [{align: []}],
            ]
        };
    }
}
